import { EcosystemActivityItem } from '../ecosystem-activity-item';
import { OrganizationItem } from '../organization-item';
import { Button } from '../widgets/button/button';
import { Pane } from './pane';
import * as cn from 'classnames';
import { ReactComponent as ArrowRight } from '../../assets/arrow-right.svg';
import { useFilter, useFilterDispatch } from '../../contexts/filter-context';
import { useHover, useHoverDispatch } from '../../contexts/hover-context';
import _ from 'lodash';
import { useNavigation } from '../../contexts/navigation-context';
import { useEffect, useState } from 'react';

export const EcosystemRolePane = ({ ecosystemRoles: roles, ecosystemActivities: activities, visible }) => {
  const { to } = useNavigation();
  const { activityIds: selectedActivityIds, roleIds: selectedRoleIds } = useFilter();
  const dispatchFilter = useFilterDispatch();

  const [role, setRole] = useState();

  const { activityIds: hoveredActivityIds, roleIds: hoveredRoleIds } = useHover();
  const dispatchHover = useHoverDispatch();

  useEffect(() => {
    if (selectedRoleIds.length > 0) {
      setRole(roles.find((r) => r.ID === selectedRoleIds?.[0]));
    }
  }, [selectedRoleIds]);

  // console.log('EcosystemRolePane(): ecosystemActivities = %o', ecosystemActivities);

  const handleRoleHovered = (roleIds, isHovered) => {
    dispatchHover({ type: isHovered ? 'role-hovered' : 'role-unhovered', roleIds });
  };

  const handleActivityHovered = (activityIds, isHovered) => {
    dispatchHover({ type: isHovered ? 'activity-hovered' : 'activity-unhovered', activityIds });
    const as = activities.filter((ea) => _.castArray(activityIds).includes(ea.ID));
    const allRoleIds = as.reduce((p, c) => [...p, ...c.ROLE_IDS], []);
    handleRoleHovered(allRoleIds, isHovered);
    dispatchHover({ type: isHovered ? 'role-hovered' : 'role-unhovered', roleIds: allRoleIds });
  };

  const isActivityHovered = (activityId) => {
    return hoveredActivityIds.length > 0 && _.difference(hoveredActivityIds, [activityId]).length === 0;
  };

  const handleActivitySelected = (activityId) => {
    dispatchFilter({ type: 'activity-set', activityId });
    const as = activities.filter((ea) => _.castArray(activityId).includes(ea.ID));
    const allRoleIds = as.reduce((p, c) => [...p, ...c.ROLE_IDS], []);
    dispatchFilter({ type: 'role-set', roleId: allRoleIds });
  };

  const handleShowOrganizationsClicked = () => {
    to({ pageId: 'organization-search' });
  };

  const handleClose = () => {
    dispatchFilter({ type: 'role-toggled', roleId: role.ID });
  };

  return (
    <Pane visible={visible} onClose={handleClose}>
      <>
        <div className="paneSection">
          <div className="paneHint">Ecosystem Role</div>
          <div className="paneTitle">{role?.NAME}</div>
          <div className="paneDescription">{role?.DESCRIPTION}</div>
        </div>
        <div className="paneSection">
          <div className="paneSubTitle">Ecosystem Activities</div>
          <div className="paneListContainer">
            {activities
              .filter((a) => (a.ROLE_IDS || []).includes(role?.ID))
              .map((a) => (
                <div
                  className={cn('selectablePanelItem ecosystemActivity', isActivityHovered(a.ID) ? 'hover' : '')}
                  onMouseOver={() => handleActivityHovered(a.ID, true)}
                  onMouseOut={() => handleActivityHovered(a.ID, false)}
                  onClick={() => handleActivitySelected(a.ID)}
                >
                  <div className="label">
                    <EcosystemActivityItem activity={a} />
                  </div>
                </div>
              ))}
          </div>
          {/* <div style={{ marginTop: 32 }}>
          <Button size="normal" icon={<ArrowRight />} textAlign="left" color="highlight" onClick={handleShowOrganizationsClicked}>
            Show organizations
          </Button>
        </div> */}
        </div>
      </>
    </Pane>
  );
};
